import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {savingsOverTimeAmt} from '../../objects/CommonUse/savingsOverTimeCalc_function';
import SixColumnDisplayCard from '../shared-components/six_column_display_card';
import SavingsCalculatorText from './text/savings_calculator_text';
import NumberedListCard from '../game-views/numbered_list_card';
import SavingsExerciseDataset from './Datasets/savings_exercise_dataset';
import { doubleToStringMonthly } from '../../objects/CommonUse/double_functions';
import { Tooltip } from '@mui/material';

class SavingsOverTimeModal extends Component {
  constructor(props) {
    super(props);
    this.state={
         callRender: false,
         expandIntroText: false,
         rerender: false,
         initialAmtTooltip: "This is the amount that you plan to deposit in the savings " +
            "account before starting the monthly deposits."
    };    
    this.savingsParmArr = [];
    this.introText = SavingsCalculatorText.introText;
    this.textArr = SavingsCalculatorText.numberedListArr;
    this.initialAmt = 0;
    this.exerciseText = "";
    this.message = "";
    this.entryTab = [];
    this.initializeDisplayClasses();
    this.resetExerciseButtons();
  }
  
  initializeDisplayClasses(){
    this.savingsTypeMsg = "";
    const defaultClass = "font-weight-bold";
    this.savingsAmtClass = defaultClass;
    this.intRateClass = defaultClass;
    this.nbrYearsClass = defaultClass;
    this.messageClass = "text-right font-weight-bold";
  }
  
  calculateSavingsOverTime(entryName){
    this.errorFound = false;
    if (entryName === "Entered"){
          this.exerciseText = "";
          this.conclusionText = "";
          this.getFormFields();
          this.editInputParameters();
          if (this.parametersValid === true){
              this.calcValuesEntered();
          }
    }else{
          this.exerciseText = "";
          this.initialAmt = 0;
          if (this.props.displayInitialAmt === true){
               document.getElementById("initialAmt").value = "";
          }
          this.calcExerciseValues(entryName);
    }
    this.setState({rerender: !this.state.rerender});
  }

  getFormFields(){
      this.initialAmtError = "";
      if (this.props.displayInitialAmt  && this.props.displayInitialAmt === true){
        this.initialAmt = document.getElementById("initialAmt").value;
      }else{
          this.initialAmt = 0;
      }
      this.savingsAmount = document.getElementById("savingsAmount").value;
      this.intRate = document.getElementById("intRate").value;
      this.nbrYears = document.getElementById("nbrYears").value;
  }

  editInputParameters(){
        this.initializeDisplayClasses();
        this.parametersValid = true;
         this.message = "";
        const labelClass = "font-weight-bold";
        if (isNaN(+this.initialAmt)){
          this.parametersValid = false;
          this.messageClass = labelClass + " text-danger";
          this.message = "Initial Amount must be numeric. Correct entry and then " +
            "click the 'Calculate' button again."
        }
        if (this.parametersValid === true){
            if (!this.savingsAmount){
                this.parametersValid = false;
                this.savingsAmtClass = labelClass + " text-danger";
            }
            if (!this.intRate){
                this.intRateClass = labelClass + " text-danger"
                this.parametersValid = false;
            }
            if (!this.nbrYears){
                this.nbrYearsClass = labelClass + " text-danger";
                this.parametersValid = false;
            }
            if (this.parametersValid === false){
                this.message = "Factor values are required and cannot be blank.";
                this.messageClass = "text-right font-weight-bold text-danger";
            }else{
            
                if (isNaN(this.savingsAmount)){
                    this.parametersValid = false;
                    this.savingsAmtClass = labelClass + " text-danger";
                }
                if (isNaN(this.intRate)){
                    this.intRateClass = labelClass + " text-danger"
                    this.parametersValid = false;
                }
                if (isNaN(this.nbrYears)){
                    this.nbrYearsClass = labelClass + " text-danger";
                    this.parametersValid = false;
                }
                if (this.parametersValid === false){
                    this.message = "Factor(s) must be numeric and no special characters (commas, dollar sign, etc.).";
                    this.messageClass = "text-right font-weight-bold text-danger";
                }
            }
      }
  }

  calcExerciseValues(exerciseName){
      switch (exerciseName){
          case "SavingsAmount":
            this.savingsAmountDisabled = true;
            break;
          case "InterestRate":
             this.interestRateButtonDisabled = true;
             break;
          case "nbrYears":
             this.nbrYearsButtonDisabled = true;
             break;
          default:
             break;
      }
      this.processExerciseValues(exerciseName);
  }

  processExerciseValues(exerciseName){
      this.savingsParmArr = [];
      this.resetExerciseButtons();
      const exerciseObj = 
        SavingsExerciseDataset.find(elem => elem.exerciseName === exerciseName);
      this.exerciseText = exerciseObj.text;
      this.conclusionText = exerciseObj.conclusion;
      const savingsParmArr = exerciseObj.parametersArr;
      for (let i=0; i<savingsParmArr.length; i++){
           this.savingsAmount = savingsParmArr[i].savingsAmount;
           this.intRate = savingsParmArr[i].intRate;
           this.nbrYears = savingsParmArr[i].nbrYears;
           this.calcValuesEntered();
      }
      this.setState({callRender: true});
  }
  
  calcValuesEntered(){   
      const intRate = this.intRate / 100;
      var totalSavingsWithInterest = savingsOverTimeAmt(this.savingsAmount, intRate, 
          this.nbrYears, this.initialAmt) 
      let intRateLit = +this.intRate + "%";
      var nbrYearsLit = (this.nbrYears + " years")
      var annualSavings = (this.savingsAmount * 12).toFixed(2);
      var totalSavingsAmount = annualSavings * this.nbrYears;
      var savingsInfoString={monthlySavingsAmt: this.savingsAmount, yearlySavingsAmt: +annualSavings,
          intRate: intRateLit, years: nbrYearsLit, totalSavingsAmt: totalSavingsAmount,
          totalSavingsWithInt: totalSavingsWithInterest}       
      this.entryTab.push(savingsInfoString);
      if (this.entryTab.length > 5){
          this.entryTab.splice(0,1);
          this.message = 
                "Max of 5 calculations, the first entry has rolled off.  Click on the 'Clear/Reset' " +
                  " button if you wish to clear all entries and start again."
      }
  }

  clearSavingsParameters(){
      this.resetExerciseButtons();
      var i;
      for (i=0; i<=this.entryTab.length; i++){
          delete this.entryTab[i];
      }
      this.entryTab = [];
      this.exerciseText = "";
      this.setState({rerender: !this.state.rerender});
  }
    
  resetExerciseButtons(){
    this.savingsAmountButtonDisabled = false;
    this.interestRateButtonDisabled = false;
    this.nbrYearsButtonDisabled = false;
    this.multipleFactorsButtonDisabled = false;
}

  expandIntroText(){
      this.setState({expandIntroText: true});
  }

  collapseIntroText(){
      this.setState({expandIntroText: false});
  }
 
  render() { 
    
    this.summaryRecordCounts = this.entryTab.map((counts,index) =>
      <SixColumnDisplayCard key={index} tableInfo={counts} index={index} tableType={"savings"}
          />
    );  
    if (this.state.expandIntroText === true){
        this.numberedList = this.textArr.map((textLine, key) =>
            <NumberedListCard key={key} text={textLine} />
      );
    }

  return <>
    <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="lg" scrollable="true"
         dialogClassName="extraCredit-modal-size" animation={false}>
      <Modal.Header className="backgroundTopBottom" closeButton>
        <Modal.Title>Savings Over Time Calculator</Modal.Title> 
      </Modal.Header>
      <Modal.Body>
        
        {this.props.calculatorSw === false  ?
        <span>
          <div className="row-100 ml-2 mr-2 mt-1 mb-4">
               There are three factors that affect the amount that you save over time.  The factors are:  The
               amount that you save each month, the extra amount that you will get paid (interest rate) as
               an incentive, and how long you save the money.  As a general rule, the longer that you
               can save money, the more the money will earn in interest.  
               
               {this.state.expandIntroText ?
                    <div className="mt-2">
                        {this.introText}  
                        {this.numberedList}
                 
                        <span className="text-right">
                            <Button variant="outline-info" size="sm"
                                onClick={() => this.collapseIntroText()}>
                                    Display Less
                            </Button>
                        </span>
                    </div>
              :   
                    <span className="ml-4">
                        <Button variant="outline-info" size="sm"
                            onClick={() => this.expandIntroText()}>
                                Display More
                        </Button>
                    </span> 
              }
                
          </div>  
        </span>
        :
            null
         }
        {this.props.displayInitialAmt ?
                <div >
                    <Tooltip title={this.state.initialAmtTooltip} arrow>
                  <label className="font-weight-bold" htmlFor="initialAmt">
                    Initial Deposit Amount:&nbsp;&nbsp;</label>
                    </Tooltip>
                  <input type="text" id="initialAmt" name="initialAmt" >
                    </input>
                    {this.initialAmtError === "" && this.initialAmt > 0 ?
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;
                        <b>Initial Amount Is:</b>&nbsp;&nbsp;{doubleToStringMonthly(this.initialAmt)}</span>
                    :
                        null
                    }
                    <span className="text-danger">
                        &nbsp;{this.initialAmtError}</span>
                  
                </div>
                :
                null
        }

      <div className="container">
          <div className="row justify-content-center align-items-center">

          {/* Monthly Savings Amount */}
              <div className="col-md-4.5 d-flex align-items-center p-2">
                  <label htmlFor="savingsAmount" className={`${this.savingsAmtClass} mb-0 mr-2`}
                    style={{ whiteSpace: 'nowrap' }} >
                    Monthly Savings Amt:
                  </label>
                  <input type="text" className="form-control" id="savingsAmount" name="savingsAmount"
                    style={{ maxWidth: '100px' }} />
              </div>

          {/* Interest Rate */}
              <div className="col-md-3.5 d-flex align-items-center ml-2 p-2">
                <label htmlFor="intRate" className={`${this.intRateClass} mb-0 mr-2`}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  Interest Rate:
                </label>
                <div className="position-relative" style={{ maxWidth: '100px' }}>
                  <input type="number" className="form-control pr-4" id="intRate" name="intRate" step="0.1"/>
                  <span
                    style={{position: 'absolute', right: '10px', top: '8px', color: '#555', pointerEvents: 'none',
                      userSelect: 'none',
                    }} >
                    %
                  </span>
                </div>
          </div>

          {/* Number of Years */}
              <div className="col-md-3 d-flex align-items-center ml-2 p-2">
                  <label htmlFor="nbrYears" className={`${this.nbrYearsClass} mb-0 mr-2`}
                    style={{ whiteSpace: 'nowrap' }} >
                    Nbr Years:
                  </label>
                  <input type="text" className="form-control" id="nbrYears" name="nbrYears"
                    style={{ maxWidth: '100px' }} />
              </div>

          </div>
        </div>

          <table className="table table-hover">
            <thead>
              <tr className="thead-light">
                <th></th>
                <th className="p-0 text-center" scope="col">Monthly Savings Amount</th>
                <th className="p-0 text-center" scope="col">Yearly Savings Amount</th>
                <th className="p-0 text-center" scope="col">Interest Rate</th>
                <th className="p-0 text-center" scope="col">Number of Years</th>
                <th className="p-0 text-center" scope="col">Total Savings Amount</th>
                <th className="p-0 text-center" scope="col">Total Savings With Interest</th>
              </tr>
            </thead>
          <tbody>
            {this.summaryRecordCounts}
          </tbody>
        </table>
        {this.props.exerciseButtons ?
            <span>
              <div className="mt-2">
                    <b>Learn more about the savings factors:</b>  Enter your own values (above) and click the 
                    Calculate button ... OR ... click on one of the buttons below.   Click the Close button 
                    when you are done.
                    <div>
                      <Button className="mt-2"
                          disabled={this.savingsAmountButtonDisabled} variant="info"  
                          onClick={() => this.calculateSavingsOverTime("SavingsAmount")}>
                              Savings Amount
                      </Button>
                      <Button className="mt-2 ml-2"
                          disabled={this.interestRateButtonDisabled} variant="info"  
                          onClick={() => this.calculateSavingsOverTime("InterestRate")}>
                              Interest Rate
                      </Button>
                      <Button className="mt-2 ml-2"
                          disabled={this.nbrYearsButtonDisabled} variant="info"  
                          onClick={() => this.calculateSavingsOverTime("NbrYears")}>
                              Number of Years
                      </Button>
                    </div>
                </div>
                <div className="text-left">
                    {this.exerciseText}
              </div>
              {this.exerciseText !== "" ?
                  <div><b>Conclusion:</b>&nbsp;{this.conclusionText}</div>
                :
                null
              }
            </span>
        :
            null
        }
        </Modal.Body>
          <Modal.Footer className="backgroundTopBottom">
              <div  className={this.messageClass}>{this.message}</div>
              <div className="ml-2">
                  <Button variant="primary"  onClick={() => this.props.onClose()}>
                      Close
                  </Button>
                  <Button className="ml-2" variant="primary"   onClick={() => this.clearSavingsParameters()}>
                      Clear/Reset
                  </Button>
                  <Button className="ml-2" variant="primary"  onClick={() => this.calculateSavingsOverTime("Entered")}>
                      Calculate
                  </Button>
              </div>
         </Modal.Footer>
      </Modal>

      
    </>
  }

 
}
export default SavingsOverTimeModal;